import React from 'react';
import { ExternalLink } from 'lucide-react';
import games from './externalGamesData';
import '../../styles/Minigames.css';

const ExternalGamesLibrary = () => {
  const handleOpen = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="external-games">
      <div className="external-games-header">
        <h2> Frazza recommendations</h2>
      </div>

      <div className="external-games-grid">
        {games.map((game) => (
          <button
            key={game.id}
            className="game-card fancy"
            onClick={() => handleOpen(game.url)}
            aria-label={`Open ${game.title}`}
          >
            <div className="game-media">
              <img
                src={game.image}
                alt={game.title}
                loading="lazy"
                onError={(e) => { e.currentTarget.src = 'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?q=80&w=1200&auto=format&fit=crop'; }}
              />
            </div>
            <div className="game-body">
              <div className="game-header-row">
                <span className="game-category">{game.category || 'Game'}</span>
                <ExternalLink size={16} aria-hidden="true" className="game-ext-icon" />
              </div>
              <div className="game-title accent">{game.title}</div>
              {game.description && (
                <div className="game-desc">{game.description}</div>
              )}
              <div className="game-actions">
                <span className="play-button" role="img" aria-label="Play now">Play Now</span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExternalGamesLibrary;
